export type MODE_TYPE = "EXPORT" | "TEST"
// 빌드 시 변경 필 
export const MODE: MODE_TYPE = "EXPORT";